import icon from 'vue-svgicon';

icon.register({
    'regular/cash-payment-bag': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M.75 14.25v9M.75 21.75h16.5a3 3 0 0 0-3-3H10.5a3 3 0 0 0-3-3H.75M6.75 18.75h3.75M20.24 18.008a7.475 7.475 0 0 0-2.022-13.059l1.853-3.17a.679.679 0 0 0 0-.687.707.707 0 0 0-.611-.342h-7.42a.707.707 0 0 0-.609.342.679.679 0 0 0 0 .687l1.853 3.17A7.477 7.477 0 0 0 8.25 12"/><path pid="1" d="M13.7 13.844a2.224 2.224 0 0 0 1.858.875c1.139 0 2.063-.693 2.063-1.547s-.924-1.546-2.063-1.546-2.058-.693-2.058-1.548.924-1.547 2.062-1.547a2.221 2.221 0 0 1 1.858.875M15.562 14.719v1.031M15.562 7.5v1.031" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
